module.exports = require("wide-align");;